// eslint-disable-next-line no-console
var onError = function onError(errors, e) {
  return console.log(errors, e);
};

export { onError };
